import { createAPI } from '../../common'

export default {
  // 获取根文件夹
  getFolderExtRoot: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0gpmefsFyu0sppu', 'get', config, vconfig),
  // 读文件夹树
  getFolderSubList: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0gpmefsFyu0tvcMjtu', 'get', config, vconfig),
  // 保存文件夹
  postFolderExtRoot: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0gpmefsFyu0gpmefs', 'POST', config, vconfig),
  // 删除文件夹
  postFolderExtDelete: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0gpmefsFyu0efmfuf', 'POST', config, vconfig),
  // 文件夹移动
  postFolderExtMove: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0gpmefsFyu0npwf', 'POST', config, vconfig),
  // 文件夹扩展详情
  getFolderExtFolder: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0gpmefsFyu0gpmefs', 'get', config, vconfig),
  // 文件夹是否重名
  postFolderExtValidName: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0gpmefsFyu0wbmjeObnf', 'POST', config, vconfig),
  getE5AdminFlows: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60gmpxt', 'get', config, vconfig), // 读三审流程
  // 图片编辑-水印列表
  getWatermarkEditList: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0qjdGpsxbse0xbufsnbsl0fejuMjtu',
      'get',
      config,
      vconfig
    ),
  // 水印列表
  postE5listdata: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60mjtuebub', 'POST', config, vconfig),
  // 水印列表
  postE5listdataAdmin: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0f60mjtuebub', 'POST', config, vconfig),
  // 保存水印
  postWatermark: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0xbufsnbsl', 'post', config, vconfig),
  // 保存水印
  postWatermarkAdmin: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0xbufsnbsl', 'post', config, vconfig),
  // 水印详情
  getWatermark: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0xbufsnbsl', 'GET', config, vconfig),
  // 水印详情
  getWatermarkAdmin: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0xbufsnbsl', 'GET', config, vconfig),
  // 删除水印
  deleteWatermark: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0qjdGpsxbse0xbufsnbsl0efmfuf',
      'post',
      config,
      vconfig
    ),
  // 删除水印
  deleteWatermarkAdmin: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0xbufsnbsl0efmfuf', 'post', config, vconfig),
  // 设置水印状态
  postWatermarkUpdateStatus: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0xbufsnbsl0vqebufTubuvt', 'POST', config, vconfig),
  // 设置水印状态
  postWatermarkUpdateStatusAdmin: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0xbufsnbsl0vqebufTubuvt', 'POST', config, vconfig),
  // 查询水印状态
  getWatermarkCheck: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0xbufsnbsl0difdl', 'GET', config, vconfig),
  // 通用配置列表
  getConfigList: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0dpogjh0mjtu', 'GET', config, vconfig),
  // 配置保存
  postConfig: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0dpogjh', 'POST', config, vconfig),
  // 批量配置保存
  postConfigAll: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0dpogjh0tbwfBmm', 'POST', config, vconfig),
  // 按指定的DocLib读子文件夹树
  getE5FoldersByDocLibs: (config, vconfig) => {
    let _vconfig = {
      neverLoading: true,
      ...vconfig
    }
    return createAPI('customEncryptApiName-1/0nfejby.bttfu0f60gpmefst0cz0epdMjct',
      'get',
      config,
      _vconfig
    )
  },
  // 根据folder获取子文件夹树
  getE5FoldersChildren: (config, vconfig) => {
    let url = '/mediax-asset/e5/folders/children'
    let _vconfig = {
      neverLoading: true,
      ...vconfig
    }
    if (vconfig.hubConfig) {
      url = 'NEWSPLAN:/e5/folders/children'
      _vconfig.hubForward = true
      _vconfig.hub = 'e5/hub'
    }
    return createAPI(url, 'get', config, _vconfig)
  },
  /**
   * 录入链接
   * @param config
   * @param vconfig
   * @returns {*}
   */
  postRegisterLink: (config, vconfig) => {
    return createAPI('customEncryptApiName-1/0nfejby.bttfu0sfhjtufs', 'POST', config, vconfig)
  },
  //获取右键操作权限
  getActions: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60bdujpot', 'get', config, vconfig),
  //资产科删除文件夹分组
  deleteFolder: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0gpmefsFyu0efmfuf', 'post', config, vconfig),
  // 资产库重命名文件夹
  validateName: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0gpmefsFyu0wbmjeObnf', 'post', config),
  // 资产库送审、通过、驳回
  postAudit: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0bveju', 'post', config, vconfig),
  //加解锁  lockFlag=true枷锁 false解锁
  unlockAsset: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0mpdl', 'get', config, vconfig),
  // 资产库转码模版
  postE5ListData: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60mjtuebub', 'POST', config),
  // 启用模板
  postMamOpenTemplate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0ufnqmbuf0fobcmf', 'POST', config),
  // 禁用模板
  postMamForbiddenTemplate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0ufnqmbuf0gpscjeefo', 'POST', config),
  // 修改阿里云对应的模板id
  postMamAliyunId: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0ufnqmbuf0bmjzvo0je', 'POST', config),
  //获取媒资详情
  getAssetDetail: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0efubjm', 'get', config, vconfig),
  //修改媒资基本信息-传id和需修改的字段
  updateAsset: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0vqebuf', 'POST', config, vconfig),
  //获取智能审核结果
  getAssetCheckResult: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0difdlSftvmu', 'get', config, vconfig),
  //获取智能识别结果
  getAssetIntellResult: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0joufmmSftvmu', 'get', config, vconfig),
  // 修改智能识别结果
  setAssetIntellResult: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0tfuJoufmmSftvmu', 'POST', config, vconfig),
  // 删除附件
  deleteAssetAtt: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0efmfufBuu', 'POST', config, vconfig),
  //获取敏感提示
  getAssetSensitiveTips: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0tfotjujwfUjqt', 'get', config, vconfig),
  // 获取分组下文件夹列表
  postFolderList: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0gpmefsMjtu', 'POST', config, vconfig),
  // 移动操作
  postMove: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0npwf', 'POST', config, vconfig),
  // 提交操作
  postPersonSubmit: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0qfstpoBttfu0tvcnju!', 'POST', config, vconfig),
  // 获取下载信息
  getDownloadList: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0hfuEpxompbe', 'POST', config, vconfig),
  //图片打包下载
  getPhotoDownload: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0epxompbe', 'get', config, vconfig),
  //文档下载
  getDocDownload: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0gjmf0qbsu0epxompbeCzQbui',
      'post',
      config,
      vconfig
    ),
  //获取当前用户图片打包队列
  getPhotoDownloadTask: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0epxompbe0ubtl', 'get', config, vconfig),
  // 保存稿件批注
  postAssetAnnotation: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0boopubujpo', 'POST', config, vconfig),
  // 获取批注列表
  postAssetLnnotationList: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0boopubujpoMjtu', 'POST', config, vconfig),
  // 权限接口
  getE5AdminDomDoclibs: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0gpmefsFyu0sppu', 'get', config, vconfig), // 读文档库树
  getE5AdminDomFolders: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0gpmefsFyu0tvcMjtu', 'get', config, vconfig), // 读子文件夹树
  getE5AdminPermissionsActionsFolder: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
      'get',
      config,
      vconfig
    ), // 读角色权限：文件夹操作权限
  postE5AdminPermissionsActionsFolder: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
      'post',
      config,
      vconfig
    ), // 保存角色权限：文件夹操作权限
  // 根据选择版本获取修改痕迹
  getArticlesTracesByVersion: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0usbdfWfstjpo0tfmfdu', 'get', config, vconfig),
  // 修改痕迹 - 所有
  getAllArticlesTraces: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0usbdfWfstjpo0bmm', 'get', config),
  // 获取不同用户修改痕迹(新)
  getArticlesTracesByDifUserNew: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0usbdfWfstjpo0bmufsobufVtfsUsbdf',
      'get',
      config,
      vconfig
    ),
  // 语音识别导出
  getMamVideoExportDistinguish: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0fyqpsuEjtujohvjti', 'GET', config),
  // 添加视频打点
  postMamVideoPoint: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0wjefp0tbwfQpjou', 'POST', config),
  // 删除视频打点
  postMamVideoPointDel: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0wjefp0efmfufQpjou', 'POST', config),
  // 获取视频转码进度
  postMamTransPercent: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0nbn0vqmpbe0usbot0qfsdfou!', 'post', config, {
      neverLoading: true,
      noHideLoading: true,
      noShowLoading: true
    }),
  // 视频快运解析
  postTransportParsed: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0wjefp0usbotqpsu', 'POST', config),
  // 视频快运注册
  postTransportRegister: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0wjefp0usbotqpsuSfhjtufs', 'POST', config),
  // 生产库将base64格式图片转为内网地址的接口
  postBase64Upload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0dvuQjd', 'POST', config, {
      neverLoading: true,
      isSimpleSecurity: true
    }),
  // 播放器裁剪视频
  postVideoClip: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0wjefp0dmjq', 'POST', config),
  // 视觉模型策略列表
  getVisualStrategyList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0dpogjh0mjtu', 'GET', config),
  // 保存视觉模型策略
  saveVisualStrategy: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0dpogjh', 'POST', config),
  // 视觉模型删除
  deleteVisualStrategy: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0dpogjh0efmfuf', 'POST', config),
  // 视觉模型ai解析
  visualStrategyAnalysis: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0tusbufhzBobmztjt', 'POST', config),
  // 视觉模型-获取解析结果
  getStrategyAnalysis: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0hfuBobmztjt', 'GET', config),
  // 视觉模型-是否购买视觉大模型配置项
  getStrategyParam: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0hfuQbsbn', 'GET', config)
}
